import { UnderwritingStatus } from '@40seas/entities/underwriting';
import { EnumColor } from '@40seas/frontend/common/providers';

export const underwritingStatusColorMapping = {
    [UnderwritingStatus.Done]: 'success',
    [UnderwritingStatus.Failed]: 'error',
    [UnderwritingStatus.InProgress]: 'info',
    [UnderwritingStatus.Pending]: 'default',
    [UnderwritingStatus.Blocked]: 'info',
} as { [key in UnderwritingStatus]: EnumColor };
